<template>
  <div>
    <rhcn-card-v2 :title="$t('message.refuse.klarnaRebutDrawer.customer.title')" :showOptional="!disabled">
      <template #body>
        <el-form :disabled="disabled" :model="formData" ref="customerForm">
          <div style="display: flex;justify-content: space-between;gap: 16px;">
            <el-form-item style="flex: 1;" :label="$t('message.refuse.klarnaRebutDrawer.customer.firstName')" prop="firstName">
              <el-input maxlength="20" v-model="formData.firstName"></el-input>
            </el-form-item>
            <el-form-item style="flex: 1;" :label="$t('message.refuse.klarnaRebutDrawer.customer.lastName')" prop="lastName">
              <el-input  maxlength="20" v-model="formData.lastName"></el-input>
            </el-form-item>
          </div>
          <el-form-item :label="$t('message.refuse.klarnaRebutDrawer.customer.email')" prop="email">
            <el-input maxlength="50" v-model="formData.email"></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.refuse.klarnaRebutDrawer.customer.phone')" prop="phone">
            <el-input maxlength="20" v-model="formData.phoneNumber"></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.refuse.klarnaRebutDrawer.customer.addressTitle')" prop="addressTitle">
          <AddressForm :disabled="disabled" :required="false" :data="formData.billingAddress" @update:data="formData.billingAddress = $event"/>
        </el-form-item>

        </el-form>
      </template>
    </rhcn-card-v2>
  </div>
</template>

<script>
import RhcnCardV2 from '@/componentsV2/base-cmps/card/index.vue';
import AddressForm from '@/views/transaction/refuse-manage/klarna-rebut/components/form/addressForm/index.vue';
export default {
  components: {
    RhcnCardV2,
    AddressForm,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    formData: {
      get() {
        return this.data;
      },
      set(newValue) {
        this.$emit('update:data', newValue);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

:deep(.el-input__count) {
  background-color: transparent !important;
  color: #8D98AF !important;
}

:deep(.el-descriptions__body) {
  background-color: transparent !important;
}
</style>
